import { Avatar, Box, Flex } from "@chakra-ui/react";

export interface AppRenderDetailItemProps {
    children?: JSX.Element;
    label?: string;
    value?: string | number | undefined;
    renderType?: "IMAGE";
    noOfLines?: number;
    imageUrl?: string;
    isAvatar?: boolean;
}

export const AppRenderDetailItem = ({
    children,
    label = "",
    value = "",
    renderType,
    noOfLines = 1,
    imageUrl = "",
    isAvatar = false,
}: AppRenderDetailItemProps) => {
    if (renderType === "IMAGE") {
        return isAvatar ? (
            <Avatar
                size="2xl"
                src={imageUrl}
                color={"var(--chakra-colors-primaryS10)"}
                bgColor={"var(--chakra-colors-primaryT80)"}
            ></Avatar>
        ) : (
            <Box
                w={"full"}
                h={"full"}
                backgroundImage={imageUrl}
                backgroundSize={"contain"}
                backgroundRepeat={"no-repeat"}
                backgroundPosition={"center"}
            ></Box>
        );
    }
    return (
        <>
            <Flex direction={"column"} gap={1} w={"full"}>
                {label && (
                    <Box textStyle={"mediumXs"} textDecoration={"underline"}>
                        {label}
                    </Box>
                )}
                {children ? (
                    children
                ) : (
                    <Box
                        textStyle={"regularSm"}
                        noOfLines={noOfLines ? noOfLines : 1}
                    >
                        {value ? value : "-"}
                    </Box>
                )}
            </Flex>
        </>
    );
};
